// extracted by mini-css-extract-plugin
export default {"account-blocked":"AccountBlocked_account-blocked__LO08+"};